import { postApi, getApi } from "../../../../controller/api"
import { getWithdrawStatistic } from "../../../../controller/api/statistic/withdraw"
import { API_CODE } from "../../../../controller/constants"

export const trackLogin = async (cookies, userId) => {
    return await getApi(cookies.lottmekong, API_CODE.TRACK_LOGIN, {
        userId: userId
    })
}

// export const lockUser = async (cookies, method, from, to, phone, page, successCallback) => {
//     const response = await getWithdrawStatistic(cookies.lottmekong, {
//         from: from,
//         to: to,
//         phone: phone,
//         method: method
//     }, page, 'APP')

//     if (response) {
//         successCallback(response)
//     }
// }

// export const unLockUser = async (cookie, id) => {
//     const requestData = {
//         id: id,
//     }
//     return await postApi(cookie, API_CODE.REVERT_INTERNAL_WITHDRAW, requestData)
// }